var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 258,
    viewBox: "0 0 352 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308 179C308 161.534 304.585 144.239 297.951 128.103C291.317 111.967 281.593 97.305 269.334 84.9548C257.075 72.6046 242.522 62.8079 226.505 56.124C210.489 49.4401 193.322 46 175.986 46C158.649 46 141.483 49.4401 125.466 56.124C109.449 62.8079 94.8963 72.6046 82.6376 84.9548C70.379 97.305 60.6549 111.967 54.0206 128.103C47.7359 143.389 44.3404 159.715 44 176.24",
    stroke: "#232A54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M351 176C351 153.019 346.473 130.262 337.677 109.03C328.882 87.7984 315.99 68.5066 299.738 52.2563C283.486 36.0061 264.192 23.1157 242.958 14.3211C221.724 5.52651 198.965 0.999999 175.981 1C152.997 1 130.239 5.52651 109.004 14.3211C87.7701 23.1157 68.4761 36.0061 52.2241 52.2563C35.9721 68.5066 23.0803 87.7984 14.2848 109.03C5.95284 129.143 1.45133 150.624 1 172.369",
    stroke: "#232A54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263 173C263 161.838 260.801 150.785 256.53 140.472C252.258 130.159 245.997 120.789 238.104 112.896C230.211 105.003 220.841 98.7419 210.528 94.4702C200.215 90.1986 189.162 88 178 88C166.838 88 155.785 90.1986 145.472 94.4702C135.159 98.7419 125.789 105.003 117.896 112.896C110.003 120.789 103.742 130.159 99.4702 140.472C95.1986 150.785 93 161.838 93 173L178 173H263Z",
    fill: "url(#paint0_linear_1_31)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_31",
    x1: 178,
    y1: 88,
    x2: 178,
    y2: 173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48518A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1335",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangBg);
export default __webpack_public_path__ + "static/media/lang_bg.e0b3289f2cadcd72f95985c9e08bd91c.svg";
export { ForwardRef as ReactComponent };